export default {
  EMERGENCY_FUND_AVAILABILITY_REPOSITORY: Symbol.for('EMERGENCY_FUND_AVAILABILITY_REPOSITORY'),
  GET_EMERGENCY_FUND_AVAILABILITY_QUERY: Symbol.for('GET_EMERGENCY_FUND_AVAILABILITY_QUERY'),
  EMERGENCY_FUND_STATE_MANAGER: Symbol.for('EMERGENCY_FUND_STATE_MANAGER'),
};
